import React, { useContext, useState } from "react";
import PinDashboardDialog from "../Pin/PinDashboard/PinDashboardDialog";
import { Button } from "../ui/button";
import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import AlertOverlay from "../../pages/Dashboard/AlertOverlay";
import { DashboardContext } from "../../pages/Dashboard";
import {
  deleteDashboardSectionAPI,
  fetchDashboardAPI,
  updateSectionLabelAPI,
} from "../../api/dashboardApi";

const SectionHeader = ({ sectionLabel, dashboardId, sectionId }) => {
  const [sectionValue, setSectionValue] = useState(sectionLabel);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isAlertOverlayOpen, setIsAlertOverlayOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const setDashboard = useContext(DashboardContext);

  const handleUpdateSectionLabel = async () => {
    await updateSectionLabelAPI({
      setIsLoading,
      label: sectionValue,
      dashboardId,
      sectionId,
    });
    const data = await fetchDashboardAPI({
      dashboardId,
      setIsLoading: () => {},
    });
    setDashboard(data);
    setIsDialogOpen(false);
  };

  const handleDelete = async () => {
    await deleteDashboardSectionAPI({ setIsLoading, dashboardId, sectionId });
    const data = await fetchDashboardAPI({
      dashboardId,
      setIsLoading: () => {},
    });
    setDashboard(data);
    setIsAlertOverlayOpen(false);
  };
  return (
    <div className="flex justify-between items-center w-full">
      <h2 className="capitalize text-zinc-400">{sectionLabel}</h2>
      <div className="flex gap-2 divide-x divide-zinc-700">
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
          className="flex gap-1"
        >
          <PinDashboardDialog
            value={sectionValue}
            title="Edit Section"
            description="Enter a section label name"
            handleSubmit={handleUpdateSectionLabel}
            isLoading={isLoading}
            isDialogOpen={isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            onChange={(e) => setSectionValue(e.target.value)}
          >
            <Button
              size="icon"
              className="hover:bg-zinc-700 bg-transparent rounded-full shadow-none"
            >
              <Pencil1Icon className="text-zinc-400" />
            </Button>
          </PinDashboardDialog>

          <AlertOverlay
            isAlertOverlayOpen={isAlertOverlayOpen}
            setIsAlertOverlayOpen={setIsAlertOverlayOpen}
            isLoading={isLoading}
            handleContinue={handleDelete}
            title={`Are you sure you want to delete the ${sectionLabel}?`}
            description="This action will permanently delete all sections within the section and cannot be undone."
          >
            <Button
              size="icon"
              className="hover:bg-zinc-700  bg-transparent rounded-full shadow-none"
            >
              <TrashIcon className="text-zinc-400" />
            </Button>
          </AlertOverlay>
        </div>

        <div className="mr-2"></div>
      </div>
    </div>
  );
};

export default SectionHeader;
